import type * as SchemaTypes from '../../../../apolloClient.types';

import type { WeightPerformanceResultFragment, WeightPerformanceResultDataFragment } from '../Create/CreatePerformanceWeightResult.api';
import { gql } from '@apollo/client';
import { WeightPerformanceResultFragmentDoc, WeightPerformanceResultDataFragmentDoc } from '../Create/CreatePerformanceWeightResult.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePerformanceWeightResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateWeightResultInput;
}>;


export type UpdatePerformanceWeightResultMutation = (
  { __typename: 'Mutation' }
  & { updateWeightResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'UpdateWeightResultSuccessfulResponse' }
    & { result: (
      { __typename: 'PerformanceResult' }
      & WeightPerformanceResultFragment
    ) }
  ) }
);


export const UpdatePerformanceWeightResultDocument = /*#__PURE__*/ gql`
    mutation UpdatePerformanceWeightResult($id: ObjectID!, $input: UpdateWeightResultInput!) {
  updateWeightResult(id: $id, input: $input) {
    ... on UpdateWeightResultSuccessfulResponse {
      result {
        ...WeightPerformanceResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${WeightPerformanceResultFragmentDoc}
${WeightPerformanceResultDataFragmentDoc}`;
export type UpdatePerformanceWeightResultMutationFn = Apollo.MutationFunction<UpdatePerformanceWeightResultMutation, UpdatePerformanceWeightResultMutationVariables>;

/**
 * __useUpdatePerformanceWeightResultMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceWeightResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceWeightResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceWeightResultMutation, { data, loading, error }] = useUpdatePerformanceWeightResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceWeightResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceWeightResultMutation, UpdatePerformanceWeightResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceWeightResultMutation, UpdatePerformanceWeightResultMutationVariables>(UpdatePerformanceWeightResultDocument, options);
      }
export type UpdatePerformanceWeightResultMutationHookResult = ReturnType<typeof useUpdatePerformanceWeightResultMutation>;
export type UpdatePerformanceWeightResultMutationResult = Apollo.MutationResult<UpdatePerformanceWeightResultMutation>;
export type UpdatePerformanceWeightResultMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceWeightResultMutation, UpdatePerformanceWeightResultMutationVariables>;